import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getStoreListByStoreId = (StoreId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_STORE_LIST_BY_STORE_ID(StoreId)
  );
};

export default getStoreListByStoreId;
